import dateFormat from 'date-fns/format';
import locale from 'date-fns/locale/pt-BR';
import parse from 'date-fns/parse';

export function formatDate(date: Date | string | null | undefined, format: string = 'dd/MM/yyyy') {
  date = parseDate(date);
  if (!date) return '';
  return dateFormat(date, format, { locale });
}

export function parseDate(date: string | Date | null | undefined): Date | null | undefined {
  if (date === null) {
    return null;
  }

  if (date === undefined) {
    return undefined;
  }

  if (date instanceof Date) {
    return date;
  }

  if (isValidDateString(date)) {
    return new Date(date);
  }

  if (/^(\d{4})-(\d{2})-(\d{2})$/.test(date)) {
    return parse(date, 'yyyy-MM-dd', new Date());
  }

  return parse(date, 'yyyy-MM-dd HH:mm:ss', new Date());
}

function isValidDateString(value: any): boolean {
  return /^(\d{4})-(\d{2})-(\d{2})([T\s](\d{2}):(\d{2}):(\d{2})(\.(\d+)(Z)?)?)?$/.test(value);
}
